<r1-compass-lib-typeahead-search
    placeholder="Type to search"
    [valueFormControl]="valueFormControl"
    [displayFormControl]="displayFormControl"
    [searchResults]="searchedFilesAndFolders()"
    resultDisplayPropertyPath="name"
    resultValuePropertyPath="name"
    [disabled]="false"
    [minimumCharactersToSearch]="0"
    (search)="onTypeaheadSearch($event)"
    (resultSelection)="onTypeaheadSelection($event)"
    [icons]="[
        { matchingField: 'description', icon: 'file' },
        { matchingField: 'parentFolderId', icon: 'folder' },
    ]"
    (clearForm)="onClearSearch()" />
<table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 demo-table">
    @for (column of nonActionColumns(); track column) {
        <ng-container [matColumnDef]="column.columnDef">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by {{ column.header }}">
                {{ column.header }}
            </th>

            <td mat-cell *matCellDef="let row; let index = index" (click)="onRowSelect(row, column)">
                @if (column.type === 'date') {
                    {{ row[column.columnDef] | date: 'yyyy-MM-dd HH:mm:ssZZZ' }}
                } @else {
                    @if (column.columnDef === 'name') {
                        <span class="name">
                            @if (row.parentFolderId !== undefined) {
                                <mat-icon fontIcon="folder" />
                            }
                            {{ row[column.columnDef] }}
                        </span>
                    } @else if (column.columnDef === 'enabled') {
                        {{
                            row[column.columnDef] === true
                                ? 'Enabled'
                                : row[column.columnDef] === false
                                  ? 'Disabled'
                                  : ''
                        }}
                    } @else if (column.columnDef === 'dependencyCount') {
                        @if (row[column.columnDef] === undefined) {
                            <span>{{ row.parentFolderId === undefined ? 'Loading...' : '' }}</span>
                        } @else {
                            <button
                                class="options"
                                mat-button
                                onclick="blur()"
                                (click)="openDependencies.emit(row.item)"
                                type="button">
                                {{ row[column.columnDef] }} play{{ row[column.columnDef] !== 1 ? 's' : '' }}
                            </button>
                        }
                    } @else {
                        {{ row[column.columnDef] }}
                    }
                }
            </td>
        </ng-container>
    }
    @for (column of actionColumns(); track column) {
        <ng-container [matColumnDef]="column.columnDef">
            <th mat-header-cell *matHeaderCellDef>
                {{ column.header }}
            </th>
            <td mat-cell *matCellDef="let row; let index = index" (click)="onRowSelect(row, column)">
                <button class="options" mat-button [matMenuTriggerFor]="optionsMenu" type="button">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #optionsMenu="matMenu">
                    @for (option of row.actions; track $index) {
                        @if (option.value) {
                            <button
                                mat-menu-item
                                (click)="clickOption.emit({ optionValue: option.value, item: row.item })"
                                [attr.data-testid]="option.display"
                                type="button">
                                {{ option.display }}
                            </button>
                        }
                    }
                </mat-menu>
            </td>
        </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns()"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns()"></tr>
</table>

<mat-paginator [pageSizeOptions]="[50, 10, 25]" showFirstLastButtons aria-label="Select page of periodic elements" />
